const sharedMobileDesktop = require('../pages/content/orderSupport_'+language+'.js');

export default {
  large: [

      // name: 'Problems with your order?',

      // fixedSection: {
      //   sectionType: 'toc',
      //   data: {
      //     headline: sharedMobileDesktop.headline,
      //     index: sharedMobileDesktop.index,
      //     paging: false,
      //   },
      // },

      // sharedData: {
      //   currentSubSection: 0,
      //   scrollingPosition: null,
      // },

      // scrolledSection: {
      //   name: 'ExpandableFaq',
      //   sectionType: 'expandable-list',
      //   data: {
      //     active: null,
      //     expandableGroups: sharedMobileDesktop.list
      //   },
      // },

      {
        sectionType: 'subsections',

        data: {
          color: 'offBlackOnOffWhite',
          sections: [
            {
              full: {
                component: 'flex-block',
                data: {
                  // blockModifiers: ['endMargin'],
                  headerSize: 'large',
                  header1: sharedMobileDesktop.headline,
                  text2: sharedMobileDesktop.text,
                }
              },
            }
          ]
        },
      },


      // {
      //   sectionType: 'subsections',

      //   data: {
      //     color: 'offBlackOnOffWhite',
      //     sections: [
      //       {
      //         top:{
      //           component: 'flex-block',
      //           data: {
      //             columns: 2,
      //             // blockModifiers: ['centerAlignText', 'headerMargin'],
      //             text2: "<strong>Enter Spotin reference no. -> Find seller contact info</strong>",
      //           }
      //         },
      //         bottom: {
      //           component: 'flex-block',
      //           data: {
      //             columns: 2,
      //             // blockModifiers: ['endMargin'],
      //             component2: {
      //               type: 'find-seller-contact',
      //               data: {

      //               },
      //             }
      //           }
      //         },
      //       }
      //     ]
      //   },
      // },


      {
        sectionType: 'subsections',

        data: {
          color: 'offBlackOnOffWhite',
          blockModifiers: ['noPaddingTop'],
          sections: [
            {
              // full: {
              //   component: 'expandable-list',
              //   data: {
              //     active: null,
              //     expandableGroups: sharedMobileDesktop.list
              //   },
              // },
              full: {
                component: 'flex-block',
                data: {
                  columns: 2,
                  blockModifiers: ['endMargin'],
                  component2: {
                    type: 'expandable-list',
                    data: {
                      active: "0-0",
                      expandableGroups: sharedMobileDesktop.list
                    },
                  }
                }
              },
            }
          ]
        },
      },


  ],
};



// WEBPACK FOOTER //
// ./pages/Ordersupport.js